/*
  Like PathsPseudoCodeSnippet, this is a one-off fake code snippet that changes its syntax highlighting based on some dynamic props.
*/

import React from 'react';
import { styled } from '@linaria/react';

import type { Command } from './SelfDrawingPath.types';

interface Props {
  commands: Array<Command>;
  highlightedCommandIndex: number | null;
}

function SelfDrawingPseudoCodeSnippet({
  commands,
  highlightedCommandIndex,
}: Props) {
  return (
    <Wrapper data-has-active-point={highlightedCommandIndex !== null}>
      <div>
        <Pink>{`<svg`}</Pink> <Purple>{`viewBox=`}</Purple>
        <Gray>{`"0 0 16 16"`}</Gray>
        <Pink>{`>`}</Pink>
      </div>
      <div>
        {'  '}
        <Pink>{`<path`}</Pink>
      </div>
      <div>
        {'    '}
        <Purple>{`d=`}</Purple>
        <Gray>"</Gray>
      </div>
      {commands.map((command, index) => (
        <div key={index}>
          {'      '}
          <Point
            data-is-active={highlightedCommandIndex === index}
          >{`${command.type[0].toUpperCase()} ${command.to.x},${
            command.to.y
          }`}</Point>
        </div>
      ))}
      <div>
        {'    '}
        <Gray>{`"`}</Gray>
      </div>
      <div>
        {'  '}
        <Pink>{`/>`}</Pink>
      </div>
      <Pink>{`</svg>`}</Pink>
    </Wrapper>
  );
}

const Wrapper = styled.pre`
  font-size: 1rem;
  font-family: var(--font-family-mono);
  font-weight: var(--font-weight-medium);
  white-space: pre;
  padding: 16px;
`;

const Color = styled.span`
  transition:
    opacity 200ms,
    color 200ms;

  ${Wrapper}[data-has-active-point='true'] & {
    color: var(--color-text);
    opacity: 0.5;
  }
`;

const Pink = styled(Color)`
  color: var(--syntax-prop);
`;

const Purple = styled(Color)`
  color: var(--syntax-name);
`;

const Gray = styled(Color)`
  color: var(--syntax-val);
`;

const Point = styled(Gray)`
  &[data-is-active='true'] {
    color: var(--wham-primary-500) !important;
    opacity: 1 !important;
  }
`;

export default React.memo(SelfDrawingPseudoCodeSnippet);
